import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/utils/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';


export function VerifyEmail() {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token');
      return;
    }
    const verify = async () => {
      try {
        await axios.get(`${API}/verify/email/confirm`, { params: { token } });
        setStatus('success');
        setMessage('Email verified successfully');
      } catch (e) {
        setStatus('error');
        setMessage(e.response?.data?.detail || 'Verification failed');
      }
    };
    verify();
  }, [location.search]);

  return (
    <div className="min-h-screen bg-green-50 flex items-center justify-center p-4" data-testid="verify-email-page">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Email Verification</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div data-testid="verify-email-status">
            {status === 'loading' && 'Verifying...'}
            {status === 'success' && message}
            {status === 'error' && message}
          </div>
          <Button onClick={() => navigate('/')} data-testid="verify-email-back-login">Back to Login</Button>
        </CardContent>
      </Card>
    </div>
  );
}